import { FlexRow } from 'components/common/common_styles'
import { ButtonContainer, ButtonMain, Readout } from './stepper_styles'

const Stepper = ({ count, setCount, minimum = 0, maximum = Number.MAX_SAFE_INTEGER, accessibleTitle = '' }) =>
  <FlexRow gap={0} fit>
    <StepButton disabled={count === minimum} onClick={() => setCount(oldVal => oldVal - 1)} accessibleTitle={accessibleTitle} />
    <Readout>{count}</Readout>
    <StepButton positive disabled={count === maximum} onClick={() => setCount(oldVal => oldVal + 1)} accessibleTitle={accessibleTitle} />
  </FlexRow>

export default Stepper

const StepButton = ({ onClick, positive = false, disabled = false, accessibleTitle }) => {

  const onKeyDown = event => {
    if (event.key === 'Enter') {
      onClick()
      event.preventDefault()
    }
  }

  return (
    <ButtonContainer
      onKeyDown={onKeyDown}
      onClick={onClick}
      disabled={disabled}
      type='button'
      aria-label={`${positive ? 'increment' : 'decrement'} ${accessibleTitle}`}
    >
      <ButtonMain width={24} height={24} viewBox='0 0 24 24' disabled={disabled}>
        <circle cx={12} cy={12} r={11} strokeWidth='1.5' />
        <path d='M7 12H17' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        {positive &&
          <path d='M12 17L12 7' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        }
      </ButtonMain>
    </ButtonContainer>
  )
}
